const vuetifyColors = {
    primary: '#D32946',
    secondary: '#3A0B15',
    accent: '#222222',
    error: '#7a0606',
    warning : '#de870a',
    success : '#22B285',
    white : '#ffffff',
    text : '#333333',
    charcoal : '#666666',
    textSubtle : '#938788',
    light: '#f7f7f7',
    borderLight: '#EEEEEE',
    border: '#cccccc',
    facebook: '#4267B2',
    google : '#EA4335',
};
export default vuetifyColors;
